export const formatAmount = (amount)=>{
    const formattedAmount = parseFloat(amount).toLocaleString("de-DE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        style: "currency",
        currency: "EUR"
    });
    return formattedAmount;
};
